import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, normalizeStyle as _normalizeStyle, withCtx as _withCtx, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3582f8a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "com_header_area" }
const _hoisted_2 = { class: "header_con" }
const _hoisted_3 = { class: "header_right" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header_search" }, null, -1))
const _hoisted_5 = { class: "header_nav_title" }
const _hoisted_6 = {
  key: 0,
  class: "header_nav_child"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "mobile_nav" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hamburger-1" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hamburger-2" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hamburger-3" }, null, -1))
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "mobile_nav_area"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "language_select" }
const _hoisted_21 = { class: "language_select_title" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "选择语言", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ArrowUp = _resolveComponent("ArrowUp")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_image, {
          class: "logo",
          src: _ctx.logo,
          onClick: _ctx.toIndexPage,
          fit: "cover"
        }, null, 8, ["src", "onClick"]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", {
            class: "header_nav",
            onMouseleave: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeOutShow && _ctx.changeOutShow(...args)))
          }, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navListData, (item) => {
                return _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                  class: "header_nav_item",
                  key: item.id,
                  onMouseover: _withModifiers(($event: any) => (_ctx.changeHoverShow(item.id)), ["stop"]),
                  to: item.url,
                  style: _normalizeStyle({backgroundColor: item.id === _ctx.hoverId ? 'rgb(44,62,80)' : '',color:item.id === _ctx.hoverId ? '#fff' : ''})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`${item.name}`)), 1)
                  ]),
                  _: 2
                }, 1032, ["onMouseover", "to", "style"])), [
                  [_vShow, !(item.isNotShow?.includes(_ctx.locale))]
                ])
              }), 128))
            ]),
            (_ctx.navChildrenList.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["header_child_con", _ctx.hoverId ? 'show' : ''])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navChildrenList, (item) => {
                      return _withDirectives((_openBlock(), _createElementBlock("div", {
                        class: "header_child_item",
                        key: item.id
                      }, [
                        (item.isBlank)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: item.url,
                              target: "_blank"
                            }, _toDisplayString(_ctx.$t(`${item.name}`)), 9, _hoisted_7))
                          : (_openBlock(), _createBlock(_component_router_link, {
                              key: 1,
                              to: item.url
                            }, {
                              default: _withCtx(() => [
                                (item.name === 'nav.EVIBB' && _ctx.locale != 'ja')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t(`nav.EVIBB01`)) + " " + _toDisplayString(_ctx.$t(`nav.EVIBB02`)), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t(`${item.name}`)), 1))
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                      ], 512)), [
                        [_vShow, !(item.isNotShow?.includes(_ctx.locale))]
                      ])
                    }), 128))
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ], 32),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(["mobile_nav_icon", _ctx.isChooseNavBar ? 'mobile_nav_btn_close' : 'mobile_nav_btn']),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isChooseNavBar = !_ctx.isChooseNavBar))
            }, _hoisted_14, 2)
          ])
        ])
      ])
    ]),
    (_ctx.isChooseNavBar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navListData, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id
            }, [
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass(["nav_item", _ctx.nowUrl === item.url ? 'active_nav_item' : ''])
              }, [
                _createElementVNode("span", {
                  onClick: ($event: any) => (_ctx.toOtherPage(item))
                }, _toDisplayString(_ctx.$t(`${item.name}`)), 9, _hoisted_16),
                (item.children && item.children.length && !item.isChoosed)
                  ? (_openBlock(), _createBlock(_component_el_icon, {
                      key: 0,
                      onClick: ($event: any) => (item.isChoosed = !item.isChoosed)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowDown)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (item.children && item.children.length && item.isChoosed)
                  ? (_openBlock(), _createBlock(_component_el_icon, {
                      key: 1,
                      onClick: ($event: any) => (item.isChoosed = !item.isChoosed)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowUp)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ], 2), [
                [_vShow, !(item.isNotShow?.includes(_ctx.locale))]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: child.id
                }, [
                  _withDirectives(_createElementVNode("div", {
                    class: _normalizeClass(["nav_item nav_child_item", _ctx.nowUrl === child.url ? 'active_nav_item' : '']),
                    onClick: ($event: any) => (_ctx.toOtherPage(child))
                  }, [
                    (child.name === 'nav.EVIBB' && _ctx.locale != 'ja')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t(`nav.EVIBB01`)) + " " + _toDisplayString(_ctx.$t(`nav.EVIBB02`)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t(`${child.name}`)), 1))
                  ], 10, _hoisted_17), [
                    [_vShow, !(child.isNotShow?.includes(_ctx.locale)) && !child?.isShowInMobile]
                  ])
                ], 512)), [
                  [_vShow, item.isChoosed]
                ])
              }), 128))
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              (!_ctx.isChoosedLanguage)
                ? (_openBlock(), _createBlock(_component_el_icon, {
                    key: 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isChoosedLanguage = !_ctx.isChoosedLanguage))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowDown)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isChoosedLanguage)
                ? (_openBlock(), _createBlock(_component_el_icon, {
                    key: 1,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isChoosedLanguage = !_ctx.isChoosedLanguage))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowUp)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _withDirectives(_createElementVNode("div", {
              class: "language_select_con",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeLanguage('en')))
            }, "English", 512), [
              [_vShow, _ctx.isChoosedLanguage]
            ]),
            _withDirectives(_createElementVNode("div", {
              class: "language_select_con",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeLanguage('zhCn')))
            }, "中文", 512), [
              [_vShow, _ctx.isChoosedLanguage]
            ]),
            _withDirectives(_createElementVNode("div", {
              class: "language_select_con",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeLanguage('ja')))
            }, "日本语", 512), [
              [_vShow, _ctx.isChoosedLanguage]
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}